import ModalSaleCode from './ModalSaleCode'
export default ModalSaleCode